import { Activity, BellRing, Cpu, DoorOpen, Radio, Thermometer, ToggleRight, Video } from 'lucide-react';
import type { DeviceKind } from '@iot-dashboard/shared';
import { KIND_LABELS } from '@iot-dashboard/shared';

const ICONS = {
  environmental: Thermometer,
  entry: DoorOpen,
  motion: Activity,
  relay: ToggleRight,
  gateway: Radio,
  sensor: Cpu,
  camera: Video,
  doorbell: BellRing,
  unknown: Cpu,
} as const;

export function KindIcon({ kind, size = 16 }: { kind: DeviceKind; size?: number }) {
  const Icon = ICONS[kind] ?? Cpu;
  return <Icon size={size} aria-label={KIND_LABELS[kind]} style={{ color: 'var(--text-secondary)', flexShrink: 0 }} />;
}
